// frontend/src/pages/BlogAdminPage.js

import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useAuth } from '../context/AuthContext';
import { useBlog } from '../context/BlogContext';
import { useBlogModal } from '../context/BlogModalContext';
import BlogAdminPanel from '../components/BlogAdminPanel';

const AccessDeniedWrapper = styled.div`
  padding: 2rem;
  text-align: center;
  color: ${({ theme }) => theme.text || '#000'};
`;

const BlogAdminPage = () => {
  const { isAuthenticated, authChecked, can } = useAuth();
  const { blog } = useBlog();
  const { openBlogSelectModal } = useBlogModal();

  useEffect(() => {
    if (authChecked && isAuthenticated && !blog) {
      openBlogSelectModal(() => {});
    }
  }, [authChecked, isAuthenticated, blog, openBlogSelectModal]);

  if (!authChecked) return null;
  if (!blog) return null; // modal is likely open

  const hasAccess = can('blog:manage_settings');

  if (!hasAccess) {
    return (
      <AccessDeniedWrapper>
        <h2>🚫 Access Denied</h2>
        <p>You need blog admin permissions to access this page.</p>
      </AccessDeniedWrapper>
    );
  }

  return <BlogAdminPanel blog={blog} />;
};

export default BlogAdminPage;
